<template>
  <el-input class="color-input" placeholder="例:rgba(255, 255, 255, 0.6)"
            @click.native="openColorPicker"
            v-model="colorValue" @change="onInputValChange">
        <span slot="suffix">
             <i class="myico-colors" style="color: #000000"></i>
             <color-picker ref="colorRef" @click.native="openColorPicker"
                           :showGradient="showGradient"
                           show-alpha
                           popper-class="picker-no-button"
                           class="input-color-picker"
                           :predefine="predefineColors"
                           @onGradientColorChange="onGradientColorChange"
                           @active-change="onBgColorChange"
                           v-model="colorValue"></color-picker>
        </span>
  </el-input>
</template>
<script>
    import colorPicker from '../color-picker'

    export default {
        components: {colorPicker},
        props: {
            value: String,
            showGradient: Boolean,
            predefineColors: Array
        },
        data() {
            return {
                colorValue: null
            };
        },
        watch: {
            value: {
                handler(v) {
                    if (this.colorValue !== v) {
                        this.init();
                    }
                },
                immediate: true
            },
        },
        methods: {
            init() {
                this.colorValue = this.value;
            },
            openColorPicker() {
                this.$refs.colorRef.$el.querySelector('.el-color-picker__icon').click();
            },
            change(value) {
                this.$emit('input', value);
                this.$emit('onChange', value);
            },
            onBgColorChange(value) {
                this.change(value)
            },
            onInputValChange(value) {
                this.change(value)
            },
            onGradientColorChange(list) {
                this.$emit('onGradientColorChange', list);
            },
        }
    }
</script>
<style lang="scss">
  @import "index";
</style>